import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import EsqueciSenha from './pages/EsqueciSenha';
import RedefinirSenha from './pages/RedefinirSenha';
import CriarConta from './pages/CriarConta';
import Dashboard from './pages/Dashboard';
import Empreendimentos from './pages/Empreendimentos';
import GruposEmpresariais from './pages/GruposEmpresariais';
import EmpreendimentoDetalhes from './pages/EmpreendimentoDetalhes';
import ProcessoLicenciamentoDetalhes from './pages/ProcessoLicenciamentoDetalhes';
import ProcessosLicenciamento from './pages/ProcessosLicenciamento';
import Licencas from './pages/Licencas';
import ValidarExtracao from './pages/ValidarExtracao';
import Tarefas from './pages/Tarefas';
import TarefasKanban from './pages/TarefasKanban';
import Documentos from './pages/Documentos';
import Home from './pages/Home';
import Configuracoes from './pages/Configuracoes';
import Relatorios from './pages/Relatorios';
import GestaoUsuarios from './pages/GestaoUsuarios';
import AdminUsuarios from './pages/AdminUsuarios';
import Layout from './components/Layout';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/esqueci-senha" element={<EsqueciSenha />} />
          <Route path="/redefinir-senha" element={<RedefinirSenha />} />
          <Route path="/criar-conta" element={<CriarConta />} />
          <Route path="/" element={<Home />} />
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/empreendimentos"
            element={
              <PrivateRoute>
                <Layout>
                  <Empreendimentos />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/grupos-empresariais"
            element={
              <PrivateRoute>
                <Layout>
                  <GruposEmpresariais />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/empreendimentos/:empreendimento_id/usuarios"
            element={
              <PrivateRoute>
                <Layout>
                  <GestaoUsuarios />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/empreendimentos/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <EmpreendimentoDetalhes />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/licencas"
            element={
              <PrivateRoute>
                <Layout>
                  <Licencas />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/processos-licenciamento"
            element={
              <PrivateRoute>
                <Layout>
                  <ProcessosLicenciamento />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/processos-licenciamento/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <ProcessoLicenciamentoDetalhes />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/licencas/:id/validar"
            element={
              <PrivateRoute>
                <Layout>
                  <ValidarExtracao />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/tarefas"
            element={
              <PrivateRoute>
                <Layout>
                  <Tarefas />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/tarefas/kanban"
            element={
              <PrivateRoute>
                <Layout>
                  <TarefasKanban />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/relatorios"
            element={
              <PrivateRoute>
                <Layout>
                  <Relatorios />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/documentos"
            element={
              <PrivateRoute>
                <Layout>
                  <Documentos />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/configuracoes"
            element={
              <PrivateRoute>
                <Layout>
                  <Configuracoes />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/usuarios"
            element={
              <PrivateRoute>
                <Layout>
                  <AdminUsuarios />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
